import { jsPDF } from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode"; // Install with: npm install qrcode
import websiteLogo from "../assets/CityHunters-logo.png";
import { registerUniSansFont } from "../assets/Sangyo-E4ywr-normal";

export const downloadVoucher = async ({ 
    coupon, 
    voucherName, 
    voucherWish, 
    endDate, 
    gameName, 
    gameDescription, 
    imageUrl,
    language = "en" 
}) => {
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

    // ✅ Register the Cyrillic font properly
    registerUniSansFont(doc);
    doc.setFont("Sangyo-E4ywr", "normal"); // Set the font

    // Define text based on language
    const texts = {
        en: {
            title: "Gift Voucher",
            coupon: "Coupon Code:",
            recipient: "Recipient:",
            wish: "Wish:",
            useBefore: "Use Before:",
            game: "Game:",
            description: "Description:",
        },
        bg: {
            title: "Подаръчен Ваучер",
            coupon: "Код на ваучера:",
            recipient: "Получател:",
            wish: "Пожелание:",
            useBefore: "Валиден до:",
            game: "Игра:",
            description: "Описание:",
        },
    };

    const t = texts[language] || texts.en; // Default to English

    // 📌 Background Styling
    doc.setFillColor(240, 240, 240); // Light Gray Background
    doc.rect(0, 0, 210, 297, "F");

    // 📌 Add Title with Fancy Style
    doc.setTextColor(50, 50, 150);
    doc.setFontSize(30);
    //doc.setFont("Sangyo-E4ywr", "bold");
    doc.text(t.title, 55, 40);

    // 📌 Decorative Line Under Title
    doc.setDrawColor(0, 0, 255);
    doc.setLineWidth(1);
    doc.line(50, 45, 160, 45);

    // 📌 Add Game & Website Logos
    doc.addImage(websiteLogo, "PNG", 10, 10, 40, 40);
    doc.addImage(imageUrl, "JPG", 160, 10, 40, 40);

    // 📌 Coupon Details Box
    doc.setFillColor(255, 255, 255); // White Box
    doc.roundedRect(20, 55, 170, 50, 5, 5, "F");

    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text(`${t.coupon} ${coupon}`, 25, 65);
    doc.text(`${t.recipient} ${voucherName}`, 25, 75);
    doc.text(`${t.wish} ${voucherWish}`, 25, 85);
    doc.text(`${t.useBefore} ${formatEndDate(endDate)}`, 25, 95);

    // 📌 Game Details Box
    doc.setFillColor(230, 230, 250); // Light Purple
    doc.roundedRect(20, 110, 170, 180, 5, 5, "F");

    doc.setFontSize(18);
    doc.setTextColor(80, 80, 120);
    doc.text(`${t.game} ${gameName}`, 25, 120);
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`${t.description} ${gameDescription}`, 25, 130, { maxWidth: 160 });

    // 📌 Generate QR Code (for coupon redemption)
    //const qrCodeDataURL = await QRCode.toDataURL(coupon);
    //doc.addImage(qrCodeDataURL, "PNG", 85, 170, 40, 40);
    //doc.setFontSize(10);
    //doc.text("Scan to redeem", 90, 215);

    // 📌 Final Border
    doc.setDrawColor(0, 0, 255);
    doc.roundedRect(5, 5, 200, 287, 10, 10, "D");

    // 🎉 Save the voucher
    doc.save("CityHuntersGiftVoucher.pdf");
};

// Helper function to format the end date
const formatEndDate = (endDate) => {
    const parsedDate = new Date(endDate);
    return parsedDate.toLocaleDateString(); // Formats the date based on the user's locale
};
